exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cell__columnIndewal-module___1_rse {\n  border: 1px solid red;\n  background-color: red;\n}\n", ""]);

// Exports
exports.locals = {
	"cell": "cell__columnIndewal-module___1_rse"
};